angular.module('stack.common.storage.services.LocalStorageService', [
  'stack.common.storage.services.StorageParserService'
])

/**
 * The LocalStorageService service provides methods to handle local storage operations.
 *
 * @class LocalStorageService
 * @constructor
 * @module stack.common.storage.services.LocalStorageService
 */
.factory('LocalStorageService', [
  '$window',
  'StorageParserService',
  function ($window, StorageParserService) {
    'use strict';

    var service = {
      /**
       * Property houses the storage type.
       *
       * @property storageType
       * @type String
       */
      storageType: 'Local',

      /**
       * Method returns the value of the stored key.
       *
       * @param {string} key - Key identifier for a property
       * @return {*} Value of the stored property
       */
      get: function get(key) {
        var value = StorageParserService.parse($window.localStorage.getItem(key));
        return value;
      },

      /**
       * Method stores the value on the passed key property.
       *
       * @param {string} key - Key identifier for a property
       * @param {string} value - Value for the stored property
       */
      set: function set(key, value) {
        $window.localStorage.setItem(key, StorageParserService.stringify(value));
      },

      /**
       * Method removes the value from storage.
       *
       * @param {string} key - Key identifier for a property
       */
      remove: function remove(key) {
        $window.localStorage.removeItem(key);
      },

      /**
       * Method clears all properties from storage.
       */
      clear: function clear() {
        $window.localStorage.clear();
      }
    };

    return service;
  }
]);
